import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { _t } from "../util/Translator";
import { HashLink } from "react-router-hash-link";

class Footer extends Component {
  state = {};
  render() {
    return (
      <Fragment>
        <footer className="zero-text-hanken">
          {/* FOOTER Desktop */}
          <div className="zero-footer zero-text-hanken zero-lh-1 zero-text-regular d-none d-lg-flex">
            <div className="container-fluid">
              <div className="row zero-bg-white">
                {/* <div className="elipse-footer"><img className="img-fluid" src="/footer-elipse.svg" alt="Footer elipse" /></div> */}
              </div>
            </div>
            <div className="container zero-container zero-border-footer pb-5">
              <div className="row zero-text-18 ">
                <div className="col-12 col-lg-3 pr-lg-5">
                  <p className="zero-text-bold zero-text-22">
                    {_t("footer.contacto")}
                  </p>
                  <p>C/ Bravo Murillo 377 28020 Madrid</p>
                  <p>
                    <a
                      href="mailto:info@hubtalent.es"
                      className="zero-text-color-primary"
                    >
                      info@hubtalent.es
                    </a>
                  </p>
                  <p>
                    <a
                      href="tel:+34911610300"
                      className="zero-text-color-primary"
                    >
                      +34 91 161 03 00
                    </a>
                  </p>
                </div>
                <div className="col-12 col-lg-3 pr-lg-5 pl-lg-5">
                  <p className="zero-text-bold zero-text-22">
                    {_t("footer.informacion")}
                  </p>
                  <p>
                    <HashLink to="/jobs" className="zero-text-color-primary">
                      {_t("footer.empleo")}
                    </HashLink>
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/sobre-nosotros/"
                      className="zero-text-color-primary"
                    >
                      {_t("footer.compania")}
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/contacto/"
                      className="zero-text-color-primary"
                    >
                      {_t("footer.contacto")}
                    </a>
                  </p>
                </div>
                <div className="col-12 col-lg-3 pr-lg-5 pl-lg-5">
                  <p className="zero-text-bold zero-text-22">
                    {_t("footer.legal")}
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/terminos-y-condiciones/"
                      className="zero-text-color-primary"
                    >
                      {_t("footer.termsAndConditions")}
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/politica-de-privacidad/"
                      className="zero-text-color-primary"
                    >
                      {_t("footer.privacyPolicy")}
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/proteccion-de-datos/"
                      className="zero-text-color-primary"
                    >
                      {_t("footer.dataProtection")}
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://hubtalent.es/cookies/"
                      className="zero-text-color-primary"
                    >
                      Cookies
                    </a>
                  </p>
                </div>
                <div className="col-12 col-lg-3 pl-lg-5">
                  <p className="zero-text-bold zero-text-22">
                    <img
                      className="img-fluid"
                      src={process.env.PUBLIC_URL + "/hubtalent-logo.svg"}
                      alt="Hubtalent Logo"
                    />{" "}
                  </p>
                  <p>¡Síguenos en RRSS!</p>
                  <div className="zero-social-footer">
                    <a href="https://www.linkedin.com/company/3318835?trk=prof-exp-company-name">
                      <img
                        className="img-fluid"
                        src={process.env.PUBLIC_URL + "/icono_linkedin.svg"}
                        alt="icono linkedin"
                      />
                    </a>
                    <a href="https://twitter.com/Hubtalent">
                      <img
                        className="img-fluid"
                        src={process.env.PUBLIC_URL + "/icono_twitter.svg"}
                        alt="twitter"
                      />
                    </a>
                  </div>


                </div>
              </div>
            </div>
            {/* Bottom bar */}
            <div className="row container zero-container pt-4 pb-3 pl-0 pr-0">
              <div className="col-md-4 col-4 pl-md-0 zero-text-18 pr-0">
                <p>©2023 HubTalent</p>
              </div>
              <div className="col-md-4 col-4">
                    <img
                      className="img-fluid"
                      src={process.env.PUBLIC_URL + "/logos-ue-eu.svg"}
                      alt="Financiado por la Unión Europea"
                    />
                  </div>
              <div className="col-md-4 col-4 pr-0 text-right zero-text-color-zero">
                <p>Design by Zero</p>
              </div>
            </div>
          </div>
          {/* FOOTER Mobile */}
          <div className="container-fluid d-lg-none zero-bg-footer">
            <div className="zero row accordion pr-3 d-lg-none  py-5">
              <div className="col">
                <div className="tabs">
                  <div className="tab">
                    <input id="faqs-chck2" type="checkbox" />
                    <label className="tab-label" htmlFor="faqs-chck2">
                      <h3>{_t("footer.contacto")}</h3>
                    </label>
                    <div className="tab-content">
                      <p>C/ Bravo Murillo 377 28020 Madrid</p>
                      <p>
                        <a href="mailto:info@hubtalent.es">info@hubtalent.es</a>
                      </p>
                      <p>
                        <a href="tel:+34911610300">+34 911 610 300</a>
                      </p>
                    </div>
                  </div>
                  <div className="tab">
                    <input id="faqs-chck3" type="checkbox" />
                    <label className="tab-label" htmlFor="faqs-chck3">
                      <h3>{_t("footer.informacion")}</h3>
                    </label>
                    <div className="tab-content">
                      <p>
                        <HashLink to="/jobs">
                          {_t("footer.empleo")}
                        </HashLink>
                      </p>
                      <p>
                        <a href="https://hubtalent.es/web/#SECTION_COMPANY">
                          Compañía
                        </a>
                      </p>
                      <p>
                        <a href="/contacto/">Contacto</a>
                      </p>
                    </div>
                  </div>
                  <div className="tab">
                    <input id="faqs-chck4" type="checkbox" />
                    <label className="tab-label" htmlFor="faqs-chck4">
                      <h3>{_t("footer.legal")}</h3>
                    </label>
                    <div className="tab-content">
                      <p>
                        <a href="/terminos-y-condiciones/">
                          Términos y Condiciones
                        </a>
                      </p>
                      <p>
                        <a href="/politica-de-privacidad/">
                          Política de privacidad
                        </a>
                      </p>
                      <p>
                        <a href="/proteccion-de-datos/">Protección de datos</a>
                      </p>
                      <p>
                        <a href="/cookies/">Política de cookies</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 px-0">
                <img
                  className="img-fluid mx-auto d-block"
                  src="/hubtalent-logo.svg"
                  alt="Hubtalent Logo"
                />
              </div>
              <div className="col-12 text-center pt-4 px-0">
                <p>¡Síguenos en RRSS!</p>
                <div className="zero-social-footer d-flex justify-content-center">
                  <a href="https://www.facebook.com/pages/Hubtalent/611709415527831?ref=hl">
                    <img
                      className="img-fluid"
                      src={process.env.PUBLIC_URL + "/icono-facebook-negro.svg"}
                      alt="icono facebook"
                    />
                  </a>
                  <a href="https://www.linkedin.com/company/3318835?trk=prof-exp-company-name">
                    <img
                      className="img-fluid"
                      src={process.env.PUBLIC_URL + "/icono_linkedin.svg"}
                      alt="icono linkedin"
                    />
                  </a>
                  <a href="https://twitter.com/Hubtalent">
                    <img
                      className="img-fluid"
                      src={process.env.PUBLIC_URL + "/icono_twitter.svg"}
                      alt="twitter"
                    />
                  </a>
                </div>
              </div>
              <div className="col-12 px-0 py-4 ">
                <img
                  className="img-fluid  mx-auto d-block"
                  src={process.env.PUBLIC_URL + "/logos-ue-eu.svg"}
                  alt="Financiado por la Unión Europea"
                />
              </div>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;
